import Search from 'Components/Header/Search';
import { SearchIcon, XIcon } from 'lucide-preact';
import { FunctionalComponent, h } from 'preact';
import { useCallback, useState } from 'preact/hooks';

import style from './style.scss';

const MobileSearch: FunctionalComponent = () => {
  const [showSearchBar, setShowSearchBar] = useState(false);

  const onClickHandler = () => {
    setShowSearchBar(true);
    setTimeout(() => {
      // @ts-ignore
      document.querySelector(`#searchContainer input`)?.focus();
    }, 100);
  };

  const onDismiss = useCallback(() => setShowSearchBar(false), []);

  return (
    <>
      <button type="button" className={style.searchButton} onClick={onClickHandler}>
        <SearchIcon className="size-[1em]" />
      </button>
      {showSearchBar && (
        <div className={style.searchContainer} id="searchContainer">
          <Search className={style.searchBar} onClickSuggestion={onDismiss} />
          <button type="button" className={style.close} onClick={onDismiss}>
            <XIcon className="size-[1em]" />
          </button>
        </div>
      )}
    </>
  );
};

export default MobileSearch;
